import store from '@/store';
import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import { IServicesCategory, IServicesCategoryListItem } from '@/entity/servicesCategory/services.category.types';
import {PaginationRequestType} from "@/entity/common/pagination.types";
import { ServiceCategoryCreateRequestType } from '@/form/serviceCategory/serviceCategoryCreate.types';
import { ServiceCategoryUpdateRequestType } from '@/form/serviceCategory/serviceCategoryUpdate.types';
import {ResponseDataType} from "@/form/form.types";
import { prepareFormData } from '@/store/utils/formDataHelper'

@Module({
    namespaced: true,
    name: 'servicesCategory',
    store,
    dynamic: true
})

class ServicesCategoryModule extends VuexModule implements IStoreReady  {
    serviceCategory: IServicesCategory | null = null
    categories: IServicesCategory | null = null
    servicesCategory: IServicesCategoryListItem | null = null
    serviceCategoryLoaded = false
    servicesCategoryLoaded = false
    ready = false

    @MutationAction
    async fetchAll(data?: PaginationRequestType, mode?:boolean): Promise<{ serviceCategory: IServicesCategory;  serviceCategoryLoaded: boolean }> {
        let serviceCategoryLoaded = false;
        const serviceCategory = await store.$repository.servicesCategory.fetchAll(prepareFormData(data));
        if(serviceCategory){
            serviceCategoryLoaded = true;
        }
        return { serviceCategory, serviceCategoryLoaded}
    }
    @MutationAction
    async fetch(data?: PaginationRequestType): Promise<{ categories: IServicesCategory;  serviceCategoryLoaded: boolean }> {
        let serviceCategoryLoaded = false;
        const categories = await store.$repository.servicesCategory.fetchAll(prepareFormData(data));
        if(categories){
            serviceCategoryLoaded = true;
        }
        return { categories, serviceCategoryLoaded}
    }

    @MutationAction
    async fetchData(data: PaginationRequestType,  mode?:number): Promise<{ servicesCategory: IServicesCategoryListItem  ; servicesCategoryLoaded: boolean }> {
        let servicesCategoryLoaded = false;
        const servicesCategory = await store.$repository.servicesCategory.fetchData(data);
        if (servicesCategory) {
            servicesCategoryLoaded = true;
        }
        return { servicesCategory, servicesCategoryLoaded};
    }

    @Action({rawError: true})
    async create(data: ServiceCategoryCreateRequestType): Promise<ResponseDataType> {
        console.log(data);
        return await store.$repository.servicesCategory.create(data);
    }
    @Action({rawError: true})
    async update(data: ServiceCategoryUpdateRequestType): Promise<ResponseDataType> {
        return await store.$repository.servicesCategory.update(data);
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        return await store.$repository.servicesCategory.delete(data);
    }
    @Mutation
    setReady(st:boolean){
        this.ready = st
    }
    
}

export const ServicesCategoryStore = getModule(ServicesCategoryModule);